import { Link, Button, Flex, Text } from "@chakra-ui/react";

export const CheckoutSuccessPage = () => {
  return (
    <Flex>
      <Text>Thank you for your purchase!</Text>
      <Link href="/">
        <Button>Go Home</Button>
      </Link>
    </Flex>
  );
};
